
import { IconButton, Stack } from '@mui/material';
import { Cancel, CheckCircle } from '@mui/icons-material';
import { useMemo } from 'react';
import Model from '../models/model';

const LCSCIResultButton = ({ inputProps }) => {
	const { formik, activeRecord } = inputProps;
	const lcsCIResult = useMemo(() => {
		return parseInt(formik.values.LCSCIResult);
	},[formik.values.LCSCIResult]);

	return (
		<Stack direction="row" spacing={2} sx={{
			'& .MuiIconButton-root': {
				'&.IsSelected': {
					backgroundColor: (theme) => theme.palette.divider,
				}
			}
		}}>
			<IconButton color="success" className={lcsCIResult === 1 ? 'IsSelected' : ''} onClick={() => {
				formik.setFieldValue('LCSCIResult', 1);
				activeRecord.record.LCSCIResult = 1;
			}}>
				<CheckCircle fontSize='inherit' />
			</IconButton>
			<IconButton color="error" className={lcsCIResult === 2 ? 'IsSelected' : ''} onClick={() => {
				formik.setFieldValue('LCSCIResult', 2)
				activeRecord.record.LCSCIResult = 2;
			}}>
				<Cancel fontSize='inherit' />
			</IconButton>
		</Stack>
	)
}
const model = new Model({
	name: 'EndoSystemCycle',
	showGridRefreshBtn: true,
	onFormLoad: ({ formik, activeRecord }) => {
		const  { values } = formik;
		const { record } = activeRecord;
		if (values.LCSCIResult === 0) {
			formik.setFieldValue('LCSCIResult', null);
		}
		if(values.LCSCILotNumber === '') {
			formik.setFieldValue('LCSCILotNumber', record.LCSCILotNumber);
		}
	},
	customizeSaveData: (toSave, { activeRecord }) => {
		const { record } = activeRecord; 
		toSave.CycleId = record.CycleId;
		toSave.LCSCIResult = record.LCSCIResult || null;
		activeRecord.id = record.EndoSystemCycleId;
		return toSave;
	},
	columns: [
		{ header: 'CILotNumber', field: 'LCSCILotNumber' },
		{ header: 'CIResult', field: 'LCSCIResult', customizeInput: LCSCIResultButton, required: true, type: 'number' }
	]
});
export const LCSCIResultModel = model;
export default model.createFormBase();
